import { createSelector } from 'reselect';

const selectDomain = (state) => state.gameLog;

/** The log's entries for `gameId`, oldest first, or null until they've loaded. */
export const selectLogEntries = createSelector(
  [selectDomain, (state, { gameId }) => gameId],
  (state, gameId) => (state.get('gameId') === gameId ? state.get('entries') : null),
);
